const home = {
    'home.video.title': '治愈你的世界。',
    'home.video.btn': '如何使用',
    'home.pro.learnMore': '了解更多信息',
    'home.join.title': '加入我们，共同前进',
    'home.join.btn': '成为合作伙伴',
    'home.pro.title1': 'Snailcle AI 体感健身车 S1',
    'home.pro.con1': '外观灵动，灵气十足，极简设计，没有生硬的线条，抚慰你的灵魂。',
    'home.pro.btn': '发现更多',
    'home.pro.title2': 'Snailcle AI 自发电懒人车 R1',
    'home.pro.con2': '另一款更适合你的减脂健身美容产品等待你去发现。外形小巧可爱，在都市家居风格中显得可爱精致。',
    'home.pro.title3': 'Snailcle AI 划船器 M1',
    'home.pro.con3': 'Snailcle的治疗技术产品之一，一种新的健身选择。一键收缩功能带来简单，时尚和安全回来。',
    'home.app.title': '简单方便。',
    'home.app.con': 'Snailcle应用程序让你不用再努力工作了。浏览数百个指导训练和计划，查看个性化指标，浏览正在进行的训练，并为下周安排课程。',
    'home.app.btn': '探索应用程序',
    'home.brand.title': '国际品牌，世界标准。',
    'home.brand.con': '在日本，韩国，台湾，香港，东南亚地区发售。同时打入欧洲、美国、中东市场。',
    'home.price.num': '￥ 6378',
    'home.news.title': '最近的新闻。',
    'home.news.btn': '阅读更多',
    'homeR1.price.num': '￥ 5668',
    'homeM1.price.num': '￥ 4958',
}
const product = {
    'product.play.btn': '立即播放',
    'product.title': 'AI 体感健身车 S1',
    'product.banner.title1': 'Snailcle S1 治愈你的世界。',
    'product.banner.con1': 'Snailcle S1有着蜗牛般可爱的外表，是一款充满温暖、治愈和科技的健身产品。',
    'product.banner.title2': 'Snailcle应用程序与有趣的骑行。',
    'product.banner.con2': '在Snailcle应用程序的支持下，你会发现随机骑行、程序、选择路线、比赛、教练课程等，让你的骑行充满乐趣。',
    'product.Exclusive.Features': '独家功能，在您身边工作！ ',
    'product.banner.title3': '两种风格，总有一种适合你的口味。',
    'product.banner.con3': '规格',
    'product.gifBanner.title1': '简约',
    'product.gifBanner.con1': '看起来与众不同，脱颖而出。极简主义设计，没有硬朗线条。抚慰你的灵魂！',
    'product.gifBanner.title2': '高度自动调节',
    'product.gifBanner.con2': '一旦连接到电源，Snailcle自行车将把车把和座椅高度恢复到最低位置，以便轻松跨过。',
    'product.gifBanner.title3': '轻微调整',
    'product.gifBanner.con3': '即使你想轻微调整，也不需要离开座位，只需按下把手上的按钮。',
    'product.gifBanner.title4': 'AI姿势检测',
    'product.gifBanner.con4': '在专利重力传感器识别和AI姿势计算公式的支持下，Snailcle自行车将检测您的身体运动姿势，并为您匹配最合适的阻力值。',
    'product.gifBanner.title5': 'AI姿势分析',
    'product.gifBanner.con5': '当你向前移动时，阻力会自动增加。当你坐直时，阻力会自动减小。',
    'product.imgBanner.title1': '自行车模拟',
    'product.imgBanner.con1': '它提供了一个模拟现实的循环，具有更具挑战性的斜坡模拟，感觉就像在玩游戏。',
    'product.imgBanner.title2': '乘坐简单',
    'product.imgBanner.con2': '没有目标，没有控制，当然也没有限制。这是你的免费乘车。我们只负责记录您的数据。',
    'product.imgBanner.title3': '程序骑乘',
    'product.imgBanner.con3': '为了满足您的实际需求，我们设置了一个多功能的循环程序，通过控制阻力和检测步频数据来达到预期的训练效果。',
    'product.imgBanner.title4': '课程与现实',
    'product.imgBanner.con4': '在课程中，没有任何限制，只有专业教练指导你如何训练和陪伴你；在现实生活中，除了美丽和感受真正的倾斜之外，你可以完全释放自己，努力在更短的时间内完成这条路线。',
    'product.imgBanner.title5': '循环数据概述',
    'product.imgBanner.con5': "除了每次骑行的数据外，点亮的方块还能让你更直观地了解最近锻炼的频率。",
    'product.proList.title1': '宽而柔软的鞍座',
    'product.proList.con1': '配备宽而柔软的马鞍，确保舒适，无论你踩多久、多快，你都会觉得你的锻炼尽可能愉快。',
    'product.proList.title2': 'EMS磁系统',
    'product.proList.con2': '特别设计的EMS磁性系统，具有快速响应功能，支持平稳踩下而不会颠簸。',
    'product.proList.title3': '全彩LED灯带',
    'product.proList.con3': '尾灯颜色与滚轮颜色相匹配，与您的骑行一起舞动。此指示灯还指示蓝牙的连接或断开。',
    'product.proList2.title1': '多功能车把',
    'product.proList2.con1': '一个有三个位置的把手：放松、运动、竞争',
    'product.proList2.title2': '坚固的机身，最大范围满足您的需求。',
    'product.proList2.con2': '用户身高范围：150厘米-190厘米。用户最大体重：120kg。',
    'product.proList2.title3': '睡眠模式',
    'product.proList2.con3': '如果机器在15分钟内没有任何操作，出于节能目的（不超过24V），磁性系统将停止工作。',
    'product.specificationList.title1': '装配尺寸：',
    'product.specificationList.title2': '用户体重：',
    'product.specificationList.title3': '电阻等级：',
    'product.specificationList.title4': '最大功率：',
    'product.specificationList.title5': '电源：',
    'product.specificationList.title6': '把手调整范围和方式：',
    'product.specificationList.title7': '鞍座调整范围和方式',
    'product.specificationList.con6': '190mm, 电动调节',
    'product.specificationList.con7': '170mm, 电动/手动调节',
    'product.customerReviews': '用户测评',
    'productR1.title': 'AI 懒人车 R1',
    'productR1.banner.title1': 'Snailcle R1 治愈你的世界。',
    'productR1.banner.con1': 'Snailcle R1是一款充满温暖、治愈和科技的自我动力健身产品，适合更广泛的人群。',
    'productR2.Exclusive.Features': '独家功能，为您左右工作!',
    'productR1.imgBanner.title1': '轻松上车',
    'productR1.imgBanner.con1': '功率长度可调节，释放380mm大空间。上下方便，用户高度范围:1.5m-2m。',
    'productR1.imgBanner.title2': '更容易调整',
    'productR1.imgBanner.con2': '长度记忆系统和人性化设计，最多可容纳五名家庭成员的个人设置，省去了您每次调整的麻烦。',
    'productR1.imgBanner.title3': '自发电',
    'productR1.imgBanner.con3': '采用绿色环保的自供电系统，赋予运动价值。使用过程中产生的动能可以转化为电能，为机器提供持续充足的电力，还可以为手机、平板电脑等外部设备充电。',
    'productR1.imgBanner.title4': '骑行更逼真',
    'productR1.imgBanner.con4': "R1电阻采用PMS电磁控制系统，超静音、低噪音、无失速、稳定安全。它可以在1-36级的几毫秒内加速或减速，保持动量和效率。这提供了真实的户外自行车骑行体验，以满足不同人群的运动强度要求。",
    'productR1.imgBanner.title5': '科学有效',
    'productR1.imgBanner.con5': "R1除了内置手握心率功能外，还可以连接具有心率广播功能的心率设备，包括腕带、心率带、臂章等。Snailcle APP还具有心率监测和提醒功能。",
    'productR1.proList.title1': '控制台显示器',
    'productR1.proList.con1': '配备宽而柔软的马鞍，确保舒适，无论你踩多久、多快，你都会觉得你的锻炼尽可能愉快。',
    'productR1.proList.title2': '双扶手设计',
    'productR1.proList.con2': '尾灯颜色与滚轮颜色相匹配，与您的骑行一起舞动。此指示灯还指示蓝牙的连接或断开。',
    'productR1.proList2.title1': '科技让运动不再具有挑战性',
    'productR1.proList2.con1': 'Snailcle团队独立开发了一款应用程序，集成了Al智能阻力控制、户外模拟骑行、视觉识别互动PK挑战迷你游戏，让运动不再枯燥乏味。',
    'productR1.proList2.title2': '看到你放松我，用你减肥，治愈一切科技美容产品',
    'productR1.proList2.con2': 'R1延续了第一代S1Al健身自行车的美学设计风格：可爱、小巧、精致，适合城市家庭。尾灯和TFT穿梭五色动感呼吸灯起到了画龙点睛的作用；电动伸缩座椅也突出了Snailcle品牌独特的设计理念。',
    'productR1.proList2.title3': '伸缩自如，移动方便',
    'productR1.proList2.con3': 'Snailcle品牌独特的设计理念让所有用户操作变得简单明了。',
    'productR1.banner.title3': 'TFT彩色屏幕显示。距离、热量、转速、阻力、功率、心率监测等程序骑行、免费骑行、一键存储、带位置记忆的轻松操作。外部心率设备连接。无线充电、USB充电端口均可用。',
    'productR1.specificationList.information': '产品信息',
    'productR1.specificationList.title1': '功率： ',
    'productR1.specificationList.con1': '300瓦',
    'productR1.specificationList.title2': '电源： ',
    'productR1.specificationList.con2': '自发电',
    'productR1.specificationList.title3': ' ',
    'productR1.specificationList.con3': '不需要插座',
    'productR1.specificationList.title4': '控制系统: ',
    'productR1.specificationList.con4': '磁控',
    'productR1.specificationList.title5': '飞轮重量: ',
    'productR1.specificationList.con5': '5.5kg',
    'productR1.specificationList.title6': '阻力档位: ',
    'productR1.specificationList.con6': '1-36段智能阻力调节',
    'productR1.specificationList.title7': '座椅升降: ',
    'productR1.specificationList.con7': '气动控制调节',
    'productR1.specificationList.title8': '踩踏距离: ',
    'productR1.specificationList.con8': '电动控制调节',
    'productR1.specificationList.title9': '电子表显示: ',
    'productR1.specificationList.con9': '飞梭彩屏显示',
    'productR1.specificationList.title10': '显示参数:',
    'productR1.specificationList.con10': '阻力，时间，速度，卡路里，踏频，距离，心率，功率',
    'productR1.specificationList.title11': '程序: ',
    'productR1.specificationList.con11': '12个预设训练程序',
    'productR1.specificationList.title12': ' ',
    'productR1.specificationList.con12': '时间、距离、卡路里3个倒计时模式',
    'productR1.specificationList.title13': ' ',
    'productR1.specificationList.con13': '5个用户自定义位置记忆设置选择',
    'productR1.specificationList.title14': 'App支持: ',
    'productR1.specificationList.con14': '可连接Snailcle App',
    'productR1.specificationList.title15': 'USB充电口: ',
    'productR1.specificationList.con15': '有',
    'productR1.specificationList.title16': '心率设备连接: ',
    'productR1.specificationList.con16': '是的，可以连接心率设备',
    'productR1.specificationList.title17': ' ',
    'productR1.specificationList.con17': '可支持所有具备蓝牙心率广播功能的心率设备，如手环、手表、心率带、臂带等',
    'productR1.specificationList.title18': '设备支架: ',
    'productR1.specificationList.con18': '有，可放置手机和平板',
    'productR1.specificationList.title19': '身高使用范围: ',
    'productR1.specificationList.con19': '150cm-190cm',
    'productR1.specificationList.title20': '用户最大承重:',
    'productR1.specificationList.con20': '120kg',
    'productR1.specificationList.title21': '整机组装后最小尺寸:',
    'productR1.specificationList.con21': '1335*652*1218mm',
    'productR1.specificationList.title22': '整机组装后最大尺寸:',
    'productR1.specificationList.con22': '1615*652*1218mm',
    'productR1.specificationList.Package&LoadingQty': '包装规格&装柜量',
    'productR1.specificationList.title26': '净重:',
    'productR1.specificationList.con26': '42kg',
    'productR1.specificationList.title27': '毛重:',
    'productR1.specificationList.con27': '49kg',
    'productR1.specificationList.title28': '外箱尺寸:',
    'productR1.specificationList.con28': '1300*355*625mm',
    'productR1.specificationList.title29': '20’/40’/40HQ:',
    'productR1.specificationList.con29': '88 / 189 / 216',
    'productM1.title': 'AI 划船器 M1',
    'productM1.banner.title1': 'Snailcle M1治愈你的世界。',
    'productM1.banner.con1': 'Snailcle M1外形小巧可爱，便于存放。是一款可爱精致的都市家居健身产品。',
    'productM1.banner.title2': '使用Snailcle App 划船',
    'productM1.banner.con2': '在Snailcle App的支持下，你可以使用自由划船、划船心率训练和各种划船项目课程练习，用数据记录下每一次的努力和收获。',
    'productM1.imgBanner2.title1': '自由划',
    'productM1.imgBanner2.con1': '在自由划船中，没有目标和限制。App面板将显示每个桨的实时数据，为您提供及时的反馈。',
    'productM1.imgBanner2.title2': '划船心率训练 ',
    'productM1.imgBanner2.con2': '划船心率训练是在设定心率目标的基础上调整训练强度的一种锻炼方法。这样，你所需要关注的就是你的心率。',
    'productM1.imgBanner2.title3': '程序划',
    'productM1.imgBanner2.con3': '为了满足您的实际需求，我们设置了多种划船训练方案，通过控制阻力和监测划船频率数据，达到理想的运动效果。',
    'productM1.imgBanner.title1': '家庭的新选择',
    'productM1.imgBanner.con1': '滑轨动力运动空间为700MM。从1.5米到2米，即使是300磅重的壮汉也能舒适地划船。',
    'productM1.imgBanner.title2': '简单、时尚、安全',
    'productM1.imgBanner.con2': '一键式收纳，占地面积仅0.5平方米，创造性地解决了传统划船机太长、难以收纳的问题。',
    'productM1.imgBanner.title3': '自发电',
    'productM1.imgBanner.con3': '采用绿色环保的自供电系统，让运动更有价值。使用过程中产生的动能可以转化为电能，可以为机器提供持续充足的动力，也可以为手机、pad等外部设备充电。',
    'productM1.imgBanner.title4': '划船更安静',
    'productM1.imgBanner.con4': "M1的电阻采用PMS控制系统，提供超安静，低延迟，无延迟，稳定和安全的性能。16级阻力选择，保持运动惯性和高效率，达到真实的划船体验，满足不同人群对运动强度的要求。",
    'productM1.imgBanner.title5': '科学有效的 ',
    'productM1.imgBanner.con5': "除了具有内置的手握心率功能外，M1还可以连接所有具有心率广播功能的心率设备，包括腕带、手表、心率带、臂带等。Snailcle APP还具有心率监测和提醒功能。",
    'productM1.proList2.title1': '让创意治愈你的世界，用科技根除千篇一律，将治疗科技之美带入生活',
    'productM1.proList2.con1': 'M1延续了第一代S1健身自行车的美学设计风格:可爱、小巧、精致，适合都市家庭，尾灯和TFT穿梭式五色动态呼吸灯画龙点睛;动力伸缩座椅也彰显了Snailcle品牌独特的设计理念。',
    'productM1.proList2.title2': '可自由伸缩，移动方便',
    'productM1.proList2.con2': 'Snailcle品牌独特的设计理念，让用户的一切操作都变得轻松简单。',
    'productM1.banner.title3': 'TFT彩屏显示:时间、距离、热量、计数spm、电阻、电量、心率监测等;程序化、自由化、一键存储，操作简便。外部心率设备连接，配有USB充电接口。',
    'productM1.specificationList.title1': '功率: ',
    'productM1.specificationList.con1': '300W',
    'productM1.specificationList.title2': '供电方式: ',
    'productM1.specificationList.con2': '自发电',
    'productM1.specificationList.title3': '收纳方式:',
    'productM1.specificationList.con3': '电动伸缩收纳',
    'productM1.specificationList.title4': '阻力方式:',
    'productM1.specificationList.con4': '磁控阻力',
    'productM1.specificationList.title5': '飞轮: ',
    'productM1.specificationList.con5': '2kg',
    'productM1.specificationList.title6': '阻力档位: ',
    'productM1.specificationList.con6': '1-16段智能阻力调节;',
    'productM1.specificationList.title7': '滑轨材质:',
    'productM1.specificationList.con7': '铝合金',
    'productM1.specificationList.title8': '电子表显示: ',
    'productM1.specificationList.con8': '飞梭彩屏显示',
    'productM1.specificationList.title9': '显示参数:',
    'productM1.specificationList.con9': '阻力，时间，卡路里，距离，心率，次数，奖频',
    'productM1.specificationList.title10': '程序: ',
    'productM1.specificationList.con10': '12个预设训练程序',
    'productM1.specificationList.title11': ' ',
    'productM1.specificationList.con11': '时间、距离、卡路里3个倒计时模式',
    'productM1.specificationList.title12': 'APP支持: ',
    'productM1.specificationList.con12': '可连接Snailcle App',
    'productM1.specificationList.title13': 'USB充电口: ',
    'productM1.specificationList.con13': '是',
    'productM1.specificationList.title14': '心率设备连接: ',
    'productM1.specificationList.con14': '可支持所有具备蓝牙心率广播功能的心率设备，如手环、手表、心率带、臂带等',
    'productM1.specificationList.title15': '设备支架: ',
    'productM1.specificationList.con15': '是',
    'productM1.specificationList.title16': '身高使用范围: ',
    'productM1.specificationList.con16': '150cm-190cm',
    'productM1.specificationList.title17': '用户最大承重:',
    'productM1.specificationList.con17': '120kg',
    'productM1.specificationList.title18': '整机组装收纳后最小尺寸:',
    'productM1.specificationList.con18': '1188*572*847mm',
    'productM1.specificationList.title19': '整机组装展开后最大尺寸:',
    'productM1.specificationList.con19': '1784*572*847mm',
    'productM1.specificationList.Package&LoadingQty': '包装规格&装柜量',
    'productM1.specificationList.title20': '净重:',
    'productM1.specificationList.con20': '30kg',
    'productM1.specificationList.title21': '毛重:',
    'productM1.specificationList.con21': '37kg',
    'productM1.specificationList.title22': '外箱尺寸:',
    'productM1.specificationList.con22': '1260*355*650mm',
    'productM1.specificationList.title23': '20’/40’/40HQ:',
    'productM1.specificationList.con23': '100 210 / 244',
}
const distributor = {
    'distributor.title': '销售支持',
    'distributor.toBecome': '合作共赢',
    'distributor.con': '区域品牌授权',
    'distributor.con1': '品牌合作计划',
    'distributor.con2': '全球代理商合作机会(联合品牌建设)',
    'distributor.con3': '联合产品创新',
    'distributor.con4': '共享技术进步',
    'distributor.contact': '请在下面留下您的联系方式，我们会尽快回复您。',
    'distributor.phone': '电话:',
    'distributor.email': '邮箱:',
    'distributor.workingHours': '工作时间:',
    'distributor.workingHours.con': '09:00 ~ 18:00(周一至周五)',
    'distributor.join': '加入我们，Snailcle将成为您值得信赖的全球健身品牌。'
}
const afterSales = {
    'afterSales.title': '售后',
    'afterSales.Video':'组装视频',
    'afterSales.click.download':'按此下载',
    'afterSales.app.download':'应用程序下载。',
    'afterSales.con1':'你可以直接在苹果和Google Play商店搜索“Snailcle”。',
    'afterSales.con2':'您也可以点击下面的按钮查看更多详细信息。',
    'afterSales.Assembly':'装配指导',
    'afterSales.Manual':"用户手册",
    'afterSales.FunctionGuide': '功能指引'
}
const about = {
    'about.title': '关于我们',
    'about.Story': '品牌故事。',
    'about.Story.con1': `Snailcle是一家专注于健身产品的创新型健身科技公司。它的使命是为年轻家庭打造“你的第一台健身机”，强调产品的原创性、新颖性、智能性、同质性和内容，而不是传统健身产品笨重、沉闷、黑色。SNAILCLE首款AI传感健身单车S1由公司联合创始人兼合伙人、中国科学技术大学孙浩博士带领团队，在创新概念构建、ID设计、先进多维力感知传感器、AI姿势分析算法和形态识别算法等方面进行研发，并于2022年9月投入量产。同年，S1以自主研发、自主品牌首次登陆美国众筹平台KICKSTARTER，并取得成功。随后，在香港、台湾、韩国、日本、美国、德国、以色列、印度、俄罗斯等市场销售，实现了国际化品牌战略的第一步。`,
    'about.Story.con2': 'Snailcle家族系列产品R1卧式自行车和m1划船机，以及未来的新产品都将遵循一贯的动力提升、动力扩展、动力存储的设计风格，从而激发所有Snailcle家族产品更鲜明的产品特色。',
    'about.Profile': '介绍',
    'about.technology': '酷蜗牛(厦门)科技有限公司',
    'about.join': 'Snailcle始终坚持“以客户为中心，以创新为核心，以市场为导向”的经营理念，以满足用户和客户。Snailcle品牌将逐步完善产品线、市场渠道建设、品牌建设，努力打造“新健身、新市场、新用户”的国际健身品牌。',
    'about.phone': '热线:',
    'about.email': '邮箱:',
    'about.address': '地址: ',
    'about.address.con': '中国厦门市海沧区板南路36号7楼'
}
const contact = {
    'contact.title': '联系我们',
    'contact.con1': '对我们的产品和解决方案感兴趣?',
    'contact.con2': '想买我们的产品吗?',
    'contact.con3': '成为我们的品牌大使?',
    'contact.con4': '成为经销商?',
    'contact.now': '现在联系我们!',
    'contact.message': "我们很乐意听到你的消息。请使用表格向我们发送您的信息。"
}
const support= {
    'support.title': '支持',
    'support.con1': '请使用支持表格从我们的专家那里获得专业帮助。填写表格将帮助我们的团队快速有效地解决您的问题。谢谢!',
    'support.con2': '感谢您购买Snailcle体感健身车!',
    'support.send.email': '给我们发邮件:',
    'support.con3': "咨询任何问题!我们会在24-28小时内给你答复.",
    'support.chat': '和我们聊天:',
    'support.con4': '如果您有需要立即帮助的问题或疑问，您可以点击下面与客户服务代表进行实时聊天。',
    'support.message': '一键留言',
    'support.con5': "如果我们不在，给我们发一封电子邮件到左边，我们会在24-28小时内。",
}
const shippingPolicy = {
    'shippingPolicy.title': '运输政策',
    'shippingPolicy.con1': '感谢您购买Snailcle体感健身车!',
    'shippingPolicy.con2': '我们的目标是为您提供最好的运输选择，使产品能够快速安全地交付给您。请特别注意销售区域和各自的送货政策。',
    'shippingPolicy.con3': '订单交付时间线分为两部分:',
    'shippingPolicy.time': '处理时间:',
    'shippingPolicy.time.con': '48小时内。',
    'shippingPolicy.method': '运输方法:',
    'shippingPolicy.method.con': '联邦快递、UPS、DPD和TNT……',
    'shippingPolicy.ShippingTime': '运输时间:',
    'shippingPolicy.ShippingTime.con': '5-7个工作日',
    'shippingPolicy.ShippingFee': '运输费用:',
    'shippingPolicy.ShippingFee.con': '订单满499美元免运费',
}
const formType = {
    'form.label.Name': '你的名字',
    'form.label.Company': '贵公司名称',
    'form.label.email': '邮箱',
    'form.label.Comment': '你的建议',
    'form.label.Phone': '你的手机号',
    'form.label.Country': '你的国家',
    'form.label.Model': '产品模型',
    'form.label.from': '购买',
    'form.label.Purchase': '购买证明',
    'form.label.Description': '描述',
    'form.btn.sub': '提交',
    'form.message.valid.email': '输入的邮箱无效!',
    'form.message.enter.email': '请输入你的邮箱！',
    'form.message.phone': '请输入你的手机号!',
    'form.message.comment': '请输入您的建议！',
    'form.message.enter.comment': '请在这里留下你的建议',
    'form.message.des': '请在这里留下你的描述',
    'form.message.des.input': '请输入您的描述',
    'form.message.purchase.input': '请输入您的购买凭证!',
    'form.message.from': '请输入您的购买地址!',
    'form.message.Model': '请输入您的产品型号!',
}
const whereToBuy = {
    'wheretobuy.title1': '购买渠道',
    'wheretobuy.con': '请访问我们的官方购买渠道。',
    'wheretobuy.title2': '其他购买渠道',
    'wheretobuy.Btn': '购买',
}
const header = {
    'header.menus.home': '首页',
    'header.menus.product': '产品',
    'header.menus.news': '新闻',
    'header.menus.support': '销售支持',
    'header.menus.after': '售后',
    'header.menus.about': '关于我们',
    'header.menus.contact': '联系我们',
    'header.menus.proS1': 'AI 体感健身车 S1',
    'header.menus.proR1': 'AI 自发电懒人车 R1',
    'header.menus.proM1': 'AI 自发电划船器 M1'
}
const footer = {
    'footer.menus.about': '支持',
    'footer.menus.about.About': '品牌故事',
    'footer.menus.about.Contact': '联系我们',
    'footer.menus.about.Distributor': '成为经销商',
    'footer.menus.support': '服务',
    'footer.menus.support.Support': '售后与支持',
    'footer.menus.support.Shipping': '运输政策',
    'footer.menus.support.Return': '退货和退款政策',
    'footer.menus.support.Refund': '退款政策',
    'footer.menus.support.Intellectual': '知识产权',
    'footer.menus.support.Privacy': '隐私政策',
    'footer.menus.support.Terms': '服务条款',
    'footer.menus.INFO': '信息',
    'footer.menus.INFO.App': 'App',
    'footer.menus.INFO.News': '新闻',
    'footer.menus.INFO.FAQ': '常见问题解答',
    'footer.menus.INFO.Installation': '组装视频',
    'footer.SUBSCRIBE': '订阅我们',
    'footer.enterAddress': '输入您的电子邮件地址',
    'footer.Submit': '提交',
    'footer.pages.news.title': 'Snailcle 新闻',
    'footer.pages.news.publish': '发表',
    'footer.pages.Support.title': '销售支持',
    'footer.bottom.con': '©2020 酷蜗牛（厦门）科技有限公司 版权所有 闽ICP备2024032604号-1'
}
const download = {
    'download.meta.title': 'Snailcle - 智能健身应用',
    'download.title': 'Snailcle',
    'download.subtitle': '你的智能健身旅程伙伴。',
    'download.status.ios': '正在打开 App Store...',
    'download.status.android': '正在打开 Google Play...',
    'download.store.apple.small': '下载自',
    'download.store.apple.large': 'App Store',
    'download.store.google.small': '获取于',
    'download.store.google.large': 'Google Play',
    'download.store.action': '下载',
    'download.qr.ios': 'iOS 二维码',
    'download.qr.android': 'Android 二维码',
    'download.footer.company': '©{year} 蜗牛壳（厦门）科技有限公司'
}
export default {
    ...home,
    ...product,
    ...distributor,
    ...afterSales,
    ...about,
    ...contact,
    ...support,
    ...shippingPolicy,
    ...formType,
    ...whereToBuy,
    ...header,
    ...footer,
    ...download
}
